// extracted by mini-css-extract-plugin
export var actionButton = "_as-1";
export var actionButtons = "_as-2";
export var actions = "_as-0";
export var aiUnread = "_as-10";
export var alignCenter = "_as-h";
export var backWrapper = "_as-3";
export var cellContainer = "_as-4";
export var checkboxContainer = "_as-5";
export var contentContainer = "_as-6";
export var contentHeader = "_as-8";
export var conversationsTableWrapper = "_as-s";
export var draftReplyBadgeContainer = "_as-m";
export var dropdownItem = "_as-b";
export var dropdownItemsContainer = "_as-a";
export var dropdownTitle = "_as-c";
export var errorIcon = "_as-7";
export var filter = "_as-d";
export var gray = "_as-i";
export var headerActionButtons = "_as-e";
export var headerCheckboxContainer = "_as-f";
export var icon = "_as-j";
export var menuContainer = "_as-k";
export var noMoreTicketsIcon = "_as-12";
export var noMoreTicketsSubText = "_as-13";
export var oneLine = "_as-l";
export var optionsButton = "_as-n";
export var plus = "_as-o";
export var portalButtonsWrapper = "_as-g";
export var red = "_as-p";
export var scrolledTop = "_as-9";
export var search = "_as-q";
export var selectedConversationsCount = "_as-r";
export var spinner = "_as-t";
export var strong = "_as-u";
export var summaryCell = "_as-v";
export var tableContainer = "_as-11";
export var tagContainer = "_as-w";
export var threeDots = "_as-x";
export var twoLines = "_as-y";
export var unread = "_as-z";